import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from '@reach/router'
import { Grid } from '@material-ui/core'
import ReactGA from 'react-ga'

import Header from '../molecules/Header'
import ProgressBar from '../molecules/ProgressBar'
import { BottomBar } from '../molecules/BottomBar'
import { Content } from '../atoms/Content'
import { LinkedCalendar } from '../molecules/Calendar'
import { LinkedDayFilter } from '../molecules/DayFilter'
import { LinkedHourPicker } from '../molecules/HourPicker'
import { LinkedChooseHourButton } from '../atoms/ChooseHourButton'
import { WORKFLOW_STEP_0 } from '../../store/workflow/constant'
import { LinkedBackButton, computeUrl } from '../atoms/BackButton'
import { LinkedBookingPreview } from '../molecules/BookingPreview'
import { getBookingState } from '../../store/booking/selectors'
import { getAppPDV } from '../../store/app/selectors'

export class SlotPicker extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    const { booking, pdvID } = this.props

    if (booking.services.length === 0) {
      return <Redirect to={computeUrl('/', pdvID)} noThrow />
    }
    return (
      <div>
        <Header />
        <ProgressBar activeStep={this.props.activeStep} />
        <Content>
          <LinkedBookingPreview />
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <LinkedDayFilter />
              <LinkedCalendar />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LinkedHourPicker />
            </Grid>
          </Grid>
        </Content>
        <BottomBar>
          <LinkedChooseHourButton />
          <LinkedBackButton targetStep={WORKFLOW_STEP_0}>
            Modifica servizi
          </LinkedBackButton>
        </BottomBar>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  booking: getBookingState(state),
  pdvID: getAppPDV(state)
})

export const LinkedSlotPicker = connect(mapStateToProps)(SlotPicker)
